import { useEffect } from 'react'
import { useMapboxMapContext } from '../contexts/MapboxMapContext'

export interface UsePOILayerProps {
  poiResults: any[]
  selectedPOI?: any
}

/**
 * Hook for managing POI layer rendering
 * NOTE: This hook is now deprecated - POI markers are handled by usePOIMarkers hook
 * This hook now only handles cleanup of old circle layers
 * TODO: Remove this hook entirely once migration is complete
 */
export function usePOILayer({
  poiResults,
  selectedPOI
}: UsePOILayerProps) {
  const { map, isLoaded, styleLoaded } = useMapboxMapContext()

  useEffect(() => {
    if (!map.current || !isLoaded || !styleLoaded) return

    // Remove old circle layer if it exists
    if (map.current.getLayer('poi-markers')) {
      map.current.removeLayer('poi-markers')
    }
    if (map.current.getSource('poi-markers')) {
      map.current.removeSource('poi-markers')
    }
  }, [map, isLoaded, styleLoaded])
}

